import { NgModule } from '@angular/core';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, DeferLoadingStrategy, provideConfig } from '@spartacus/core';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { MyAccountPermissionsAuthGuard } from '../../myaccount/guards/myaccount-permissions-auth.guard';
import { CheckoutCartIsValidatedGuard } from '../guards/checkout-cart-validated-guard';
import { SnappayPlaceOrderComponent } from './snappay-place-order.component';

@NgModule({
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SnappayPlaceOrderComponent: {
          component: SnappayPlaceOrderComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutCartIsValidatedGuard, MyAccountPermissionsAuthGuard],
        },
      },
    }),
    provideConfig({
      ...LaunchDialogModalLayoutConfig.Containers,
    }),
  ],
})
export class SnappayPlaceOrderModule {}
